import { StanModal } from '@/components';

export interface DuplicationLoadingModalProps {
    isOpen: boolean;
}

export function DuplicationLoadingModal({ isOpen }: DuplicationLoadingModalProps) {
    return (
        <StanModal
            id='duplication-loading-modal'
            isOpen={isOpen}
            title='Duplicating Product...'
            hideCloseButton
            nonDismissible
        >
            <div className='flex flex-col items-center gap-4 py-4'>
                <div className='border-brand-main size-12 animate-spin rounded-full border-b-2' />
                <p className='text-secondary text-center'>Please wait while we duplicate your product</p>
            </div>
        </StanModal>
    );
}
